import { render } from "./TheAlarmTypesList.vue?vue&type=template&id=67a7f5f3"
import script from "./TheAlarmTypesList.vue?vue&type=script&lang=js"
export * from "./TheAlarmTypesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__